// constants.js

export const body = document.querySelector('body');
export const viewportHeight = window.innerHeight;
export const viewportWidth = window.innerWidth;
export const screens = {
								sm: 640,
								md: 768,
								lg: 1080,
								xl: 1280,
						 }; 